import { fetcher } from '../../utility/domUtils';

export const addUpdateIdParameter = (updateId, historyPush) => {
  const url = new URL(window.location.href);
  const search_params = url.searchParams;

  search_params.set('update_id', updateId);
  url.search = search_params.toString();
  historyPush({
    pathname: window.location.pathname,
    search: search_params.toString(),
  });
};

const reaction = (campaignId, updateId, method) => {
  let resParams = {};
  return fetcher(
    `/donate/api/campaigns/${campaignId}/updates/${updateId}/reaction`,
    {
      method: method,
    }
  )
    .then((response) => {
      resParams = {
        ...resParams,
        ok: response.ok,
        statusCode: response.status,
      };
      return response.json();
    })
    .then((response) => {
      const updateRes = response?.data?.updateReaction;
      if (response?.name === 'DUPLICATE_REACTION') {
        resParams.ok = false;
      }
      return {
        ...updateRes,
        ...resParams,
        status: method === 'POST' ? 'CREATED' : 'DELETED',
      };
    })
    .catch((error) => {
      return {
        ...error,
        ...resParams,
        status: 'FAILED',
      };
    });
};

export const handleLikeUpdate = async (isLiked, campaignID, updateId) => {
  return new Promise((resolve, reject) => {
    reaction(campaignID, updateId, !isLiked ? 'POST' : 'DELETE')
      .then((response) => {
        if (response.ok) {
          return resolve(response);
        }
        const error = {
          likeState: 'ERROR',
          ...response,
        };
        return reject(new Error(JSON.stringify(error)));
      })
      .catch((error) => {
        return { ...error, likeState: 'ERROR' };
      });
  });
};
